export default "__VITE_ASSET__C3c5jzVN__"